import styled from '@emotion/styled';
import MUIIconButton from '@material-ui/core/IconButton';

export const IconButton = styled(MUIIconButton)<any>`
  && {
    padding: 4px;
    color: gray;
  }
`;
